/* Webstra 10/2026: Korrekturen fuer Gravur-Vorschau und Kaufbereich (nur Workingfile).
   Laedt nach wb-personalisierung-3.js und vor gm-layout-v2.js, damit die Daten-Ergaenzungen vor dem Aufbau greifen.
   1. Sektglas "Wunschnamen oder Text": fehlende Zeile "Text oben" in den Vermessungsdaten ergaenzen
   2. Holzbox gross: gleicher Zoom fuer alle Motive (Werte von "Eheringe")
   3. Gleiche Schriftgroesse fuer gleichrangige Zeilen (Name/Name, Text oben/unten, Glas 1/Glas 2)
   4. Datum hoechstens 10 Zeichen, Schutz gegen zu kleine Gravur
   5. Reihenfolge: Feld -> Schriftart -> naechstes Feld, Schriftarten immer mit Ueberschrift
   6. Kaufbereich ueberall gleich (Fragen-Link und Vorteile im Kasten, Artikelnummer darunter)
   7. CSS: Schrittnummern, Markierungsbox ohne Fuellung, Wunschname-Umschalter lesbar */
(function(){
  if(window.__wbFix)return;window.__wbFix=1;
  var GM=window.GM=window.GM||{};
  function $(s,r){return (r||document).querySelector(s);}
  function $$(s,r){return [].slice.call((r||document).querySelectorAll(s));}
  function txt(el){return el?(el.textContent||'').replace(/\s+/g,' ').trim():'';}
  function safe(fn){return function(){try{return fn.apply(this,arguments);}catch(e){if(window.console)console.warn('wb-fix',e);}};}

  /* ---------- 7. CSS ---------- */
  (function(){
    var s=document.createElement('style');s.id='wb-fix-css';
    s.textContent=[
      /* Ziffern optisch mittig: Nunito Sans sitzt bei line-height 1 ca. 0,02em zu hoch */
      '.gm-step__n{line-height:1!important;font-variant-numeric:tabular-nums lining-nums;padding:.05em 0 0!important;box-sizing:border-box}',
      '.gm-pdp .product-atc-btn form > .product-form__submit,.product-atc-btn form > .product-form__submit{width:100%!important;max-width:none!important}',
      '.gm-photo .gm-pe.is-focus{background:transparent!important}',
      '.product__info-container .product__sku.wb-sku{order:7!important;margin:1rem 0 0!important;font-size:1.2rem;color:#5a6369}',
      '.gm-cfg .gm-fontbox.wb-fb{margin-top:1.4rem}',
      '.gm-cfg .gm-fontbox.wb-fb + .gm-field,.gm-cfg .gm-fontbox.wb-fb + .wb-same{margin-top:1.6rem}',
      '.gm-cfg .gm-fontbox.wb-fb > .gm-label{display:block;margin:0 0 .6rem;font-weight:700;color:#14232b}',
      '.gm-cfg .wb-toolong{margin:.6rem 0 0;font-size:1.3rem;font-weight:600;color:#b3261e}',
      '.gm-cfg .wb-step4[hidden],.gm-cfg .gm-fontwrap[hidden]{display:none!important}',
      '.gm-cfg--lay.wb-arc .gm-svg text:not(.wb-arc-t){visibility:hidden!important}',
      '.gm-cfg--lay .wb-arc-bg{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}',
      '.gm-cfg--lay .gm-svg text.wb-arc-t.is-ph{fill-opacity:.6}',
      '.gm-cfg .gm-prev__note[hidden]{display:none!important}',
      '.gm-cfg--lay .gm-svg text.wb-bend-t.is-ph{fill-opacity:.6}',
      /* Wunschname-Umschalter ueberall wie .gm-wn: aktiv weiss auf blau, inaktiv dunkel auf weiss, normale Schreibweise */
      '.custom-condition-btn{display:grid!important;grid-template-columns:1fr 1fr;gap:8px}',
      '.custom-condition-btn .related-condition-btn{text-transform:none!important;letter-spacing:normal!important;font-size:14px!important;font-weight:600!important;padding:8px 10px!important;min-height:44px;width:auto!important;margin:0!important;border-radius:999px!important}',
      '.custom-condition-btn .related-condition-btn:not(.active){color:#1c1f21!important;background:#fff!important;border:1px solid #b9c6cc!important}',
      '.custom-condition-btn .related-condition-btn:not(.active):hover{border-color:#0b6e8a!important}',
      '.custom-condition-btn .related-condition-btn.active{color:#fff!important;background:#0b6e8a!important;border:1px solid #0b6e8a!important}',
      '.custom-condition-btn .related-condition-btn:focus-visible{outline:3px solid #0b6e8a;outline-offset:2px}',
      /* Set-Auswahl: Ersparnis beim 2er-Set */
      '.cust-swatch .wb-save{display:block;margin-top:.3rem;font-size:1.2rem;line-height:1.3}',
      '.cust-swatch .wb-save s{color:#5a6369;margin-right:.2rem;white-space:nowrap}',
      '.cust-swatch .wb-save b{display:inline-block;padding:.1rem .6rem;border-radius:999px;background:#e3f3e8;color:#17602f;font-weight:700;margin-top:.2rem;white-space:nowrap}'
    ].join('');
    (document.head||document.documentElement).appendChild(s);
  })();

  /* ---------- 1. Sektglas: "Text oben" ergaenzen ---------- */
  safe(function(){
    var L=window.GM_LAY,f=L&&L['gm-preview-sekt'];if(!f||!f.m)return;
    var P='sektglas-mit-gravur-leonardo-daily-';
    /* Position aus dem Produktfoto vermessen (Zeile "Wunschtext oder" ueber dem Motiv) */
    var S1={'0':[0.5007,0.1844,0.1737,[0.3738,0.146,0.6281,0.2115],[0.149,0.2112,1]]};
    var S2={'1':[0.2822,0.1844,0.1744,[0.155,0.146,0.4094,0.2115],[0.149,0.2112,1]],'2':[0.7263,0.1863,0.1737,[0.5994,0.148,0.8538,0.2133],[0.1509,0.213,1]]};
    function add(b,key,spec){
      var E=f.m[b]&&f.m[b][key];if(!E||!E.sl)return;
      if(E.sl.some(function(s){return /^\{text/.test(s[0]);}))return;
      var add=[];
      Object.keys(spec).forEach(function(g){
        var nk=g==='0'?'{name}':'{name@'+g+'}',tk=g==='0'?'{text}':'{text@'+g+'}';
        var n=E.sl.filter(function(s){return s[0]===nk;})[0];if(!n)return;
        var p=spec[g],fac=JSON.parse(JSON.stringify(n[8]||{}));
        add.push([tk,n[1],p[0],p[1],p[2],0,'Wunschtext oder',n[7],fac,p[3],null,p[4]]);
      });
      if(add.length)E.sl=add.concat(E.sl);
    }
    ['herz','doppelherz','herzlinie','herzranke1','herzranke2'].forEach(function(m){
      add('1g',P+'deine-wunschnamen-oder-text-mit-'+m+'-mit-wunschname',S1);
      add('2g',P+'deine-wunschnamen-oder-text-mit-'+m+'-2-glaser-mit-wunschname',S2);
    });
    add('2g',P+'liebesglas-taube-2-glaser-mit-wunschname-datum',S2);
  })();

  /* ---------- 1b. Bierkrug/Pilsglas "Gestalte dein Glas": zweite Zeile ergaenzen ---------- */
  /* je Slot: [Vorlage, Vorlage zum Kopieren der Schriften, x, y, Breite, Referenztext, Radierbereich, y-Grenzen] */
  safe(function(){
    var L=window.GM_LAY;if(!L)return;
    function put(pre,b,key,specs){
      var f=L[pre],E=f&&f.m&&f.m[b]&&f.m[b][key];if(!E||!E.sl)return;
      specs.forEach(function(p){
        if(E.sl.some(function(s){return s[0]===p[0];}))return;
        var n=E.sl.filter(function(s){return s[0]===p[1];})[0];if(!n)return;
        E.sl.push([p[0],n[1],p[2],p[3],p[4],0,p[5],n[7],JSON.parse(JSON.stringify(n[8]||{})),p[6],null,p[7]]);
      });
    }
    var BK='bierkrug-0-5l-mit-gravur-leonardo-taverna-bierglas-',PI='bierglas-mit-gravur-leonardo-daily-pilsglas-';
    put('gm-preview-bier','1g',BK+'gestalte-dein-glas-gluck-ist-wie-dich-zu-haben-mit-wunschname',[['{text}','{name}',0.4385,0.3244,0.283,'Wunschtext',[0.285,0.2958,0.592,0.3525],[0.2958,0.353,1]]]);
    put('gm-preview-bier','1g',BK+'gestalte-dein-glas-ranke-mit-wunschname',[['{line2}','{name}',0.4429,0.4081,0.2269,'Wunschtext',[0.32,0.3825,0.566,0.4275],[0.386,0.424,1]]]);
    put('gm-preview-bier','2g',BK+'gestalte-dein-glas-ranke-2-glaser-mit-wunschname',[['{line2@1}','{name@1}',0.2507,0.5587,0.1587,'Wunschtext',[0.16,0.542,0.342,0.573],[0.544,0.5705,1]],['{line2@2}','{name@2}',0.6401,0.3194,0.1587,'Wunschtext',[0.549,0.302,0.731,0.3335],[0.304,0.331,1]]]);
    put('gm-preview-pils','1g',PI+'gestalte-dein-glas-gluck-ist-wie-dich-zu-haben-mit-wunschname',[['{text}','{name}',0.5022,0.2427,0.1794,'Wunschtext',[0.4,0.215,0.605,0.27],[0.216,0.27,1]]]);
    put('gm-preview-pils','1g',PI+'gestalte-dein-glas-ranke-mit-wunschname',[['{line2}','{name}',0.5025,0.2957,0.1638,'Wunschtext',[0.4,0.27,0.605,0.316],[0.276,0.313,1]]]);
    put('gm-preview-pils','2g',PI+'gestalte-dein-glas-ranke-2-glaser-mit-wunschname',[['{line2@1}','{name@1}',0.2832,0.2938,0.1637,'Wunschtext',[0.19,0.269,0.376,0.314],[0.2745,0.311,1]],['{line2@2}','{name@2}',0.7194,0.2938,0.1638,'Wunschtext',[0.626,0.269,0.812,0.314],[0.2745,0.311,1]]]);
  })();

  /* ---------- 1c. Windlicht "Holy Aperoli": fehlende Vorschau ergaenzen (Name "Ramona" aus dem Produktfoto vermessen) ---------- */
  safe(function(){
    var L=window.GM_LAY;if(!L)return;
    var H='hochwertiges-glas-windlicht-mit-gravur-holy-aperoli-mit-wunschname-in-der-farbe-',FN='Holdiger_2f66829c-e2bb-4900-8ce5-56e04ddf1708',fac={};fac[FN]=[1,0.35];
    var C={ws:['weiss-silber','WS','76d0b238-d127-4914-87c4-9e81e6e5dab5','24b2ea0c-e66d-4d79-9d3d-3c9f7621ccf1'],wb:['weiss-bronze','WB','9dfd2188-a70b-4082-aa12-cc1ca7a9d2e6','0f407959-fa72-4bce-9a00-27e6ea0e75a9'],wg:['weiss-gold','WG','e51716a5-8b3b-4657-ac9d-fa5af7955784','bb21ac76-0b58-4aeb-8c1e-9502615beec0'],ss:['schwarz-silber','SS','3609f82b-6feb-4430-9010-220c46b43953','0213dfd7-c23f-40ce-997d-079e902afe2d'],sb:['schwarz-bronze','SB','61f5daee-0938-4f03-9813-4a126545f8b1','59c6fff3-f57f-4d03-8e61-21a0542d2735'],sg:['schwarz-gold','SG','9b375bb9-873d-4a7f-8f0b-6199ac284612','65aa5cb2-29d1-489d-9623-1552b0777cca']};
    Object.keys(C).forEach(function(k){
      var f=L['gm-preview-wl-'+k],c=C[k];if(!f||!f.m||!f.m['1g']||f.m['1g'][H+c[0]])return;
      f.m['1g'][H+c[0]]={L:c[1]+'_Titelbild_1_ohne_Licht_'+c[3]+'.png',V:c[1]+'_Titelbild_1_mit_Licht_'+c[2]+'.png',
        sl:[['{name}',0,0.5065,0.595,0.147,0,'Ramona',FN,JSON.parse(JSON.stringify(fac)),[0.427,0.548,0.588,0.642],[0.33,0.68],[0.551,0.68,1]]]};
    });
    /* gm-layout-data9 hat die Foto-Vorschau fuer diese Seite schon abgeschaltet (Eintrag fehlte) -> wieder einschalten */
    var p=window.GM_PREFIX||'',k=location.pathname.split('/').pop();
    if(p.indexOf('gm-preview-wl-')===0&&k.indexOf(H)===0&&!window.GM_PREVIEW&&L[p]&&L[p].m['1g'][k]){
      window.GM_PREVIEW={leer1:'/cdn/shop/files/'+p+'-1g-leer.jpg',wein1:'/cdn/shop/files/'+p+'-1g-wein.jpg'};
      window.__gmLayOwn=true;
    }
  })();

  /* ---------- 1d. Fruehstuecksbrett "Bulli Sternehotel": Wunschtext im Bogen (Bogen aus dem Produktfoto vermessen) ---------- */
  safe(function(){
    var T=window.GM_TF,p=window.GM_PREFIX||'';
    if(p!=='gm-preview-tf-br-mot'||!T||String(T.id)!=='9491971047754')return;
    var L=window.GM_LAY=window.GM_LAY||{},h=location.pathname.split('/').pop(),FN='Kaushan_Script_af2d948a-dc4d-4b0e-a7a3-0123f16f49eb',fac={};fac[FN]=[1,0.7];
    if(L[p]&&L[p].m&&L[p].m['1g']&&L[p].m['1g'][h])return;
    L[p]={sets:{'1g':{all:{x:0,y:0,w:1},surf:['#141414'],reg:[[0,0.9,0.05,0.75]],nowine:true,noun:'dem Brett',allLabel:'Ganzes Brett',wl:{l:'#906e3a',w:'#906e3a',label:'',on:false}}},m:{'1g':{}}};
    /* Grundlinie in Bildkoordinaten (0-1000): Kreismitte cx/cy, Radius r(Winkel)=a*w^2+b*w+c, Winkel a0..a1 in Grad; xh = Hoehe der Kleinbuchstaben */
    L[p].m['1g'][h]={sl:[['{text}',0,0.553,0.47,0.62,0,'Michaels Sternehotel',FN,fac,0,[0.22,0.88],[0.31,0.68,1]]],
      wbArc:{cx:569.94,cy:659.82,r:[0.0031279,0.69335,304.2],a0:-180,a1:-31,xh:38,ff:FN,ph:'Michaels Sternehotel',fill:'#9d8956',bg:'/cdn/shop/files/gm-preview-tf-br-mot-1g-leer.jpg?width=1600'}};
    if(!window.GM_PREVIEW)window.GM_PREVIEW={leer1:'/cdn/shop/files/'+T.L+'?width=1600'};
    window.__gmLayOwn=true;
  })();

  /* ---------- 1e. Einzelne Vermessungsfehler korrigieren ---------- */
  safe(function(){
    var L=window.GM_LAY;if(!L)return;
    /* Sekt LOVE (Love Name): falsch vermessene Zusatzzeile "Stefanie" auf Glas 2 (sass im "ve" und machte Glas 1 winzig) */
    var f=L['gm-preview-sekt'],E=f&&f.m&&f.m['2g']&&f.m['2g']['sektglas-leonardo-daily-br-love-2-glaser-mit-wunschname'];
    if(E&&E.sl)E.sl=E.sl.filter(function(s){return !(s[0]==='{name1}'&&s[1]===1&&s[4]<0.07);});
    /* Sekt Mr & Mrs (2 Glaeser): zweiter, falsch vermessener Name auf dem Mrs-Glas */
    E=f&&f.m&&f.m['2g']&&f.m['2g']['sektglas-mit-gravur-leonardo-daily-mr-mrs-always-right-2-glaser-mit-wunschname'];
    if(E&&E.sl)E.sl=E.sl.filter(function(s){return !(s[0]==='{name2}'&&s[1]===1&&s[4]<0.09);});
    /* Glaeser allgemein: zwei verschiedene Zeilen an exakt derselben Stelle derselben Flaeche = Messfehler, die schmalere entfaellt */
    Object.keys(L).forEach(function(pre){if(!/^gm-preview-(sekt|bier|pils|puccini)/.test(pre))return;var g=L[pre];if(!g||!g.m)return;Object.keys(g.m).forEach(function(b){Object.keys(g.m[b]).forEach(function(k){
      var F=g.m[b][k];if(!F||!F.sl||F.sl.length<2)return;var drop={};
      F.sl.forEach(function(s,i){F.sl.forEach(function(t,j){if(j<=i||s[1]!==t[1]||s[0]===t[0])return;
        if(Math.abs(s[3]-t[3])<0.012&&Math.abs(s[2]-t[2])<0.03)drop[s[4]<t[4]?i:j]=1;});});
      if(Object.keys(drop).length)F.sl=F.sl.filter(function(s,i){return !drop[i];});
    });});});
    /* Sekt "Wir trauen uns" (Ringe/Auto/Brautpaar) mit Holzbox: Datum auf beiden Glaesern fehlte in der Vermessung (aus dem Produktfoto gemessen) */
    ['ringe','auto','brautpaar'].forEach(function(m){
      var F=f&&f.m&&f.m['2ghk']&&f.m['2ghk']['sektglas-leonardo-daily-br-wir-trauen-uns-motiv-'+m+'-2-glaser-und-holzbox-klein-mit-wunschname-datum'];if(!F||!F.sl)return;
      var d=F.sl.filter(function(s){return s[0]==='{date}'&&s[1]===2;})[0];if(!d||F.sl.some(function(s){return s[0]==='{date}'&&s[1]!==2;}))return;
      [[0,0.171,0.459,0.064,[0.135,0.45,0.207,0.468],[0.11,0.23],[0.45,0.468,1]],[1,0.348,0.3715,0.064,[0.312,0.362,0.384,0.381],[0.29,0.41],[0.362,0.381,1]]].forEach(function(q){
        F.sl.push(['{date}',q[0],q[1],q[2],q[3],0,'17.06.2025',d[7],JSON.parse(JSON.stringify(d[8]||{})),q[4],q[5],q[6]]);
      });
    });
    /* Puccini LOVE mit Holzbox: kein automatisch eingefuegtes "&" (Kunden tragen es wie bei allen anderen selbst ein) */
    ['gm-preview-puccini','gm-preview-puccini-aperol','gm-preview-puccini-lillet'].forEach(function(pre){
      var g=L[pre],F=g&&g.m&&g.m['2ghg']&&g.m['2ghg']['love-2-glaeser-und-holzbox-gross-mit-wunschname'];
      if(F&&F.sl)F.sl.forEach(function(s){if(s[0]==='{name1} &')s[0]='{name1}';});
    });
  })();

  /* ---------- Hilfen: Vermessung der aktuellen Seite ---------- */
  function lay(){var W=window.__WBP;return W&&W.findLayout?W.findLayout():null;}
  var CV=document.createElement('canvas').getContext('2d');
  function met(s,ff){CV.font='100px '+ff;CV.textAlign='center';var m=CV.measureText(s);return{l:m.actualBoundingBoxLeft,r:m.actualBoundingBoxRight,a:m.actualBoundingBoxAscent,d:m.actualBoundingBoxDescent};}
  function fname(ff){return String(ff||'').split(',')[0].replace(/["']/g,'').trim();}
  function kindOf(t){var m=String(t[0]||'').match(/\{([\w@]+)\}/);return m?m[1]:'';}
  function baseKind(k){return String(k).replace(/@\d/,'');}
  var TEXTISH=/^(name|name1|name2|names|text|line2|date)$/;

  /* ---------- 2. Zoom: feste Ausschnitte je Set ---------- */
  var ZOOM={'gm-preview-puccini':{'2ghg':{s0:[-0.047,0.316,0.39],s1:[0.191,0.237,0.32],s2:[0.188,0.088,0.962]}}};
  function zoomFix(){
    var ph=$('.gm-cfg--lay .gm-photo');if(!ph||ph.__wbZoom)return;
    var l=lay();if(!l)return;
    var Z=(ZOOM[window.GM_PREFIX||'gm-preview-puccini']||{})[l.b];if(!Z)return;
    ph.__wbZoom=1;
    var layer=$('.gm-photo__layer',ph),prev=ph.closest('.gm-prev');if(!layer||!prev)return;
    function apply(){
      var b=$('.gm-seg button[aria-pressed="true"]',prev),v=b&&b.getAttribute('data-v'),z=v&&Z[v];
      if(!z)return;
      var t='scale('+(1/z[2])+') translate('+(-z[0]*100)+'%, '+(-z[1]*100)+'%)';
      if(layer.style.transform!==t)layer.style.transform=t;
    }
    new MutationObserver(safe(apply)).observe(layer,{attributes:true,attributeFilter:['style']});
    new MutationObserver(safe(apply)).observe(prev,{attributes:true,subtree:true,attributeFilter:['aria-pressed']});
    apply();
  }

  /* ---------- 3. Gleiche Schriftgroessen ---------- */
  var busy=false;
  function item(el,E,set){
    var i=+el.getAttribute('data-i'),t=E.sl[i];if(!t)return null;
    var s=el.textContent||'';if(!s.trim())return null;
    var ff=el.getAttribute('font-family')||'',p=+el.getAttribute('font-size');if(!(p>0))return null;
    var k=kindOf(t),reg=set&&set.reg&&set.reg[t[1]],sc=reg?Math.max(reg[1]-reg[0],0.01):1;
    var v=met(s,ff),fn=fname(ff),G8=t[8]&&t[8][fn],K=G8?G8[0]:1;
    var f=1000*t[4];
    /* erlaubte Breite: Grenzen aus der Vermessung (x-Bereich bzw. Maximalbreite je Schrift), sonst wie gm-layout-v2 */
    var b=t[10]?1000*(t[10][1]-t[10][0]):G8&&G8[1]?1000*G8[1]:f*(t[6].length<9?1.6:1.3);
    var cap=100*b/Math.max(v.l+v.r,1);
    var mr=met(t[6],ff),nom=100*f/Math.max(mr.l+mr.r,1)*K;
    /* Hoehe begrenzt nur, wenn die Zeile ueber ihre Designgroesse hinaus wachsen wuerde (Schreibschriften haben hohe Ober-/Unterlaengen) */
    if(t[11]){var hh=1000*(t[11][1]-t[11][0]);cap=Math.min(cap,Math.max(100*hh/Math.max(v.a+v.d,1),nom));}
    return{el:el,t:t,s:s,ff:ff,p:p,k:k,bk:baseKind(k),surf:t[1],sc:sc,v:v,cap:cap,nom:nom};
  }
  function setSize(o,pn){
    var el=o.el,v=o.v,x=+el.getAttribute('x'),y=+el.getAttribute('y'),po=o.p;
    var u=x+(v.r-v.l)/2*po/100,c=y-(v.a-v.d)/2*po/100;
    var t=o.t;
    if(t[10]){var hw=(v.l+v.r)*pn/200;u=Math.min(Math.max(u,1000*t[10][0]+hw),1000*t[10][1]-hw);}
    var yn=c+(v.a-v.d)/2*pn/100;
    if(t[11]){var Y0=1000*t[11][0],Y1=1000*t[11][1],tp=yn-v.a*pn/100,bt=yn+v.d*pn/100;if(bt-tp<=Y1-Y0){if(bt>Y1)yn-=bt-Y1;else if(tp<Y0)yn+=Y0-tp;}}
    el.setAttribute('font-size',pn.toFixed(2));
    el.setAttribute('x',(u-(v.r-v.l)/2*pn/100).toFixed(2));
    el.setAttribute('y',yn.toFixed(2));
    o.p=pn;
  }
  function equalize(){
    if(busy)return;
    var l=lay();if(!l||!l.E||!l.E.sl)return;
    var set=l.set||{},surf=set.surf||[];
    var items=$$('.gm-cfg--lay .gm-svg text[data-i]').map(function(el){return item(el,l.E,set);}).filter(Boolean);
    if(items.length<2)return;
    var par=items.map(function(_,i){return i;});
    function find(i){while(par[i]!==i){par[i]=par[par[i]];i=par[i];}return i;}
    function uni(a,b){a=find(a);b=find(b);if(a!==b)par[a]=b;}
    function glass(o){return (surf[o.surf]||'glass')==='glass';}
    function ratio(a,b){return Math.max(a,b)/Math.max(Math.min(a,b),0.01);}
    var cross={};
    for(var i=0;i<items.length;i++)for(var j=i+1;j<items.length;j++){
      var A=items[i],B=items[j];
      /* gleiche Flaeche: nur Zeilen, die im Design gleich gross gedacht sind (Referenzgroesse +-35 %) */
      if(A.surf===B.surf){if(A.ff===B.ff&&TEXTISH.test(A.bk)&&TEXTISH.test(B.bk)&&ratio(A.nom,B.nom)<1.35)uni(i,j);}
      else if(!glass(A)&&!glass(B)&&A.ff===B.ff&&A.bk===B.bk&&A.s===B.s&&surf[A.surf]===surf[B.surf])uni(i,j);
    }
    /* verschiedene Glaeser: einander entsprechende Zeilen (gleiche Reihenfolge von oben nach unten) bekommen
       dieselbe Groesse im Verhaeltnis zur Designgroesse - egal ob der Text gleich ist oder nicht */
    var bySurf={};items.forEach(function(o,i){if(glass(o)&&TEXTISH.test(o.bk))(bySurf[o.surf]=bySurf[o.surf]||[]).push(i);});
    var sk=Object.keys(bySurf);
    sk.forEach(function(k){bySurf[k].sort(function(a,b){return items[a].t[3]-items[b].t[3];});});
    for(var a=0;a<sk.length;a++)for(var b=a+1;b<sk.length;b++){
      var X=bySurf[sk[a]],Y=bySurf[sk[b]],used={};
      X.forEach(function(xi,n){
        var yi=null;
        if(X.length===Y.length)yi=Y[n];
        else Y.forEach(function(c){if(yi===null&&!used[c]&&items[c].bk===items[xi].bk)yi=c;});
        if(yi===null||ratio(items[xi].nom,items[yi].nom)>=1.5)return;
        used[yi]=1;uni(xi,yi);cross[xi]=cross[yi]=1;
      });
    }
    var groups={};items.forEach(function(o,i){var r=find(i);(groups[r]=groups[r]||[]).push(i);});
    /* Zielgroesse in einem Durchgang berechnen (stabil, keine Schleife mit dem Observer) */
    items.forEach(function(o){o.base=Math.max(o.p,Math.min(o.nom,o.cap));o.tg=o.base;});
    Object.keys(groups).forEach(function(g){
      var I=groups[g];if(I.length<2)return;
      var G=I.map(function(i){return items[i];});
      var multi=I.some(function(i){return cross[i];});
      if(multi){
        /* je Glas eine gemeinsame Designgroesse, dann ein gemeinsamer Faktor fuer alle Glaeser */
        var S={},C={};G.forEach(function(o){S[o.surf]=(S[o.surf]||0)+o.nom;C[o.surf]=(C[o.surf]||0)+1;});
        /* alle Glaeser bekommen exakt dieselbe Schriftgroesse (Mittel der Designgroessen, begrenzt durch die schmalste Flaeche) */
        var SS=0,SN=0;Object.keys(S).forEach(function(k){S[k]/=C[k];SS+=S[k];SN++;});var SC=SS/SN;
        var k=1;G.forEach(function(o){k=Math.min(k,o.cap/SC);});
        G.forEach(function(o){o.tg=k*SC;});
      }else{
        var hi=0,lo=1e9;
        G.forEach(function(o){hi=Math.max(hi,o.base/o.sc);lo=Math.min(lo,o.cap/o.sc);});
        var N=Math.min(hi,lo);
        G.forEach(function(o){o.tg=N*o.sc;});
      }
    });
    busy=true;
    try{items.forEach(function(o){if(Math.abs(o.tg-o.p)>0.05)setSize(o,o.tg);});}finally{busy=false;}
    GM.__wbItems=items;
  }
  function eqInit(){
    var svg=$('.gm-cfg--lay .gm-svg');if(!svg||svg.__wbEq)return;
    svg.__wbEq=1;
    var run=safe(equalize);
    new MutationObserver(function(){if(!busy)run();}).observe(svg,{attributes:true,subtree:true,childList:true,characterData:true,attributeFilter:['font-size','font-family','x','y']});
    run();
  }

  /* ---------- 4. Datum begrenzen, zu kleine Gravur verhindern ---------- */
  var MINR=0.5;
  function guardInit(){
    var rows=GM.rows||[],l0=lay();if(l0&&l0.E&&l0.E.wbArc)return;
    rows.forEach(function(r){
      if(!r||!r.input||r.__wbG)return;r.__wbG=1;
      var bk=baseKind(r.kind||'');
      if(bk==='date'&&!/z\.\s*B\./i.test(r.head||'')&&(!(r.input.maxLength>0)||r.input.maxLength>10)){r.input.maxLength=10;r.max=10;if(r.input.value&&r.input.value!=='OHNE'&&r.input.value.length>10)r.input.value=r.input.value.slice(0,10);}
      r.__wbOk=r.input.value;
      r.input.addEventListener('input',safe(function(){
        var v=r.input.value;
        if(v==='OHNE'||!v||!r.__wbOk||v.length<=r.__wbOk.length){r.__wbOk=v;hint(r,'');return;}
        equalize();
        var it=(GM.__wbItems||[]).filter(function(o){return o.k===r.kind;});
        var small=it.some(function(o){return o.p<MINR*o.nom;});
        if(small){r.input.value=r.__wbOk;r.input.dispatchEvent(new Event('input',{bubbles:true}));hint(r,'Der Text ist zu lang für die Gravurfläche. Bitte kürzer fassen.');}
        else{r.__wbOk=v;hint(r,'');}
      }));
    });
  }
  function hint(r,msg){
    var host=r.field||r.input.parentNode;if(!host)return;
    var p=$('.wb-toolong',host);
    if(!msg){if(p)p.remove();return;}
    if(!p){p=document.createElement('p');p.className='wb-toolong';p.setAttribute('role','status');host.appendChild(p);}
    p.textContent=msg;
    clearTimeout(r.__wbHt);r.__wbHt=setTimeout(function(){if(p.parentNode)p.remove();},4000);
  }

  /* ---------- 5. Reihenfolge und Ueberschriften der Schriftarten ---------- */
  function glassNo(r){var m=String(r.kind||'').match(/@(\d)/);if(m)return +m[1];var l=r.field&&$('.gm-label',r.field);m=txt(l).match(/Glas\s*(\d)/i);return m?+m[1]:0;}
  function noun(users){
    var k=users.map(function(r){return baseKind(r.kind||'');});
    var hasL=k.indexOf('letter')>-1,hasN=k.some(function(x){return /^name|^names/.test(x);}),hasT=k.some(function(x){return /^text|^line/.test(x);});
    if(hasL&&hasN)return 'Buchstabe und Name';
    if(hasL)return 'deinen Buchstaben';
    if(hasT&&hasN)return 'deine Gravur';
    if(hasN)return k.length>1?'deine Namen':'deinen Wunschnamen';
    return 'deinen Wunschtext';
  }
  /* 4-Felder-Glaeser: oben/unten nach der echten Position in der Vorschau benennen und sortieren */
  function maFix(){
    var l=lay(),rows=GM.rows||[];if(!l||!l.E||!l.E.sl)return;
    function yOf(r){var s=l.E.sl.filter(function(s){return String(s[0]).indexOf('{'+r.kind+'}')>-1;})[0];return s?s[3]:9;}
    [1,2].forEach(function(g){
      var rs=rows.filter(function(r){return glassNo(r)===g&&r.field;}).sort(function(a,b){return yOf(a)-yOf(b);});
      if(rs.length!==2)return;
      var host=rs[0].field.parentNode;
      rs.forEach(function(r,i){
        var pos=i?'unten':'oben';
        var lab=$('.gm-label',r.field);
        if(lab){var tn=null;[].forEach.call(lab.childNodes,function(n){if(!tn&&n.nodeType===3&&n.nodeValue.trim())tn=n;});var nt='Glas '+g+' Text '+pos;if(tn&&tn.nodeValue!==nt)tn.nodeValue=nt;}
        var bl=r.box&&$('.gm-label',r.box);if(bl&&bl.textContent!=='Glas '+g+' Schrift '+pos)bl.textContent='Glas '+g+' Schrift '+pos;
        if(r.field.parentNode===host)host.appendChild(r.field);
        if(r.box&&r.box.parentNode===host)host.appendChild(r.box);
      });
    });
  }
  function order(){
    var W=window.__WBP,ST=W&&W.ST;if(!ST||!ST.ready)return true;
    if(ST.ma){maFix();return true;}
    var wrap=$('.gm-cfg--lay');if(!wrap)return true;
    var B=$('.gm-panel',wrap),g2=$('.wb-g--2',B);
    if(!B||!g2)return true;
    var rows=GM.rows||[],own=rows.filter(function(r){return r.src===r&&r.box;});
    /* Feldbeschriftungen einheitlich: "Glas1:" -> "Glas 1:" */
    rows.forEach(function(r){var l=r.field&&$('.gm-label',r.field);if(!l)return;[].forEach.call(l.childNodes,function(n){if(n.nodeType===3&&/Glas\d/.test(n.nodeValue))n.nodeValue=n.nodeValue.replace(/Glas(\d)/g,'Glas $1');});});
    if(!own.length)return true;
    var multi=rows.some(function(r){return glassNo(r)===2;});
    var same=$('.wb-same',B);
    own.forEach(function(o){
      var users=rows.filter(function(r){return r.src===o&&r.field;});
      if(!users.length)return;
      var g1=users.filter(function(r){return glassNo(r)<=1;}),g2=users.filter(function(r){return glassNo(r)===2;});
      var last=(g1.length?g1:users)[(g1.length?g1:users).length-1],host=last.field.parentNode;
      /* Schriftart von Glas 1 gehoert immer in den Bereich von Glas 1 (nie in den aufklappbaren Glas-2-Bereich).
         Steht danach kein weiteres Feld von Glas 1, kommt sie direkt unter "2. Glas genauso wie erstes Glas". */
      var more=false,n=last.field.nextElementSibling;while(n){if(n.classList&&n.classList.contains('gm-field')){more=true;break;}n=n.nextElementSibling;}
      if(g1.length&&!more&&same&&same.parentNode){if(same.nextElementSibling!==o.box)same.parentNode.insertBefore(o.box,same.nextSibling);}
      else if(o.box.previousElementSibling!==last.field)host.insertBefore(o.box,last.field.nextSibling);
      o.box.classList.add('wb-fb');
      var lab=$('.gm-label',o.box);
      if(lab){
        var t;
        if(multi&&g1.length&&g2.length)t='Wähle eine Schriftart für beide Gläser';
        else{var g=glassNo(last);t=(multi&&g?'Glas '+g+': ':'')+'Wähle eine Schriftart für '+noun(users);}
        lab.classList.remove('gm-sr');
        if(lab.textContent!==t)lab.textContent=t;
      }
    });
    var O=$('.gm-fontwrap',B),P=$('.wb-step4',B);
    if(O&&!$('.gm-fontbox',O)){O.hidden=true;if(P)P.hidden=true;}
    var lead=$('.gm-lead',wrap);
    if(lead&&/Danach wählst du die Schriftart/.test(lead.textContent))lead.textContent='Tippe deinen Wunschtext ein und wähle darunter die Schriftart. Die Vorschau zeigt alles sofort.';
    if(W.renumber)W.renumber();
    if(!B.__wbObs){B.__wbObs=1;try{new MutationObserver(safe(function(){var O2=$('.gm-fontwrap',B),P2=$('.wb-step4',B);if(O2&&!$('.gm-fontbox',O2)&&!O2.hidden){O2.hidden=true;if(P2)P2.hidden=true;if(W.renumber)W.renumber();}})).observe(B,{childList:true});}catch(e){}}
    return true;
  }

  /* ---------- 6. Kaufbereich vereinheitlichen ---------- */
  function buyBox(){
    var info=$('.product__info-container');if(!info)return false;
    var box=$('.product-atc-btn',info);if(!box)return false;
    ['.inquiry-popup','form.contact-form','.gm-trust'].forEach(function(sel){
      $$(sel,info).forEach(function(el){if(!box.contains(el))box.appendChild(el);});
    });
    var sku=$('.product__sku',info);
    if(sku){sku.classList.add('wb-sku');if(box.nextElementSibling!==sku)box.parentNode.insertBefore(sku,box.nextSibling);}
    var inv=$('.product__inventory',info);
    if(inv&&inv.parentNode===box.parentNode){var msg=$('.atc-btn-msg',box.parentNode),ref=msg&&msg.parentNode===box.parentNode?msg:box;if(inv.nextElementSibling!==ref)box.parentNode.insertBefore(inv,ref);}
    return !!$('.gm-trust',box);
  }

  /* ---------- 9. Hinweis unter der Vorschau aus den Theme-Einstellungen ---------- */
  function noteFix(){
    if(typeof window.WB_PREV_NOTE!=='string')return;
    $$('.gm-cfg .gm-prev__note').forEach(function(p){
      var t=window.WB_PREV_NOTE.trim();
      if(!t){p.hidden=true;return;}
      p.hidden=false;if(p.textContent!==t)p.textContent=t;
    });
  }

  /* ---------- 8. Wunschtext im Bogen (Daten mit wbArc) ---------- */
  function arcInit(){
    var l=lay(),A=l&&l.E&&l.E.wbArc;if(!A)return;
    var svg=$('.gm-cfg--lay .gm-svg');if(!svg||svg.__wbArc)return;svg.__wbArc=1;
    var NS='http://www.w3.org/2000/svg',cfg=svg.closest('.gm-cfg--lay');cfg.classList.add('wb-arc');
    function rB(t){return A.r[0]*t*t+A.r[1]*t+A.r[2];}
    function pth(a0,a1,dr){var d='';for(var t=a0;t<=a1;t+=1){var r=rB(t)+dr,w=t*Math.PI/180;d+=(d?'L':'M')+(A.cx+r*Math.cos(w)).toFixed(1)+' '+(A.cy+r*Math.sin(w)).toFixed(1);}return d;}
    /* Originaltext im Foto mit dem leeren Brett (gleiches Foto) ueberdecken - eigene Ebene ohne Multiplizieren */
    var bg=document.createElementNS(NS,'svg');bg.setAttribute('class','wb-arc-bg');bg.setAttribute('viewBox','0 0 1000 1000');bg.setAttribute('preserveAspectRatio','none');bg.setAttribute('aria-hidden','true');
    bg.innerHTML='<defs><mask id="wbArcM" maskUnits="userSpaceOnUse" x="0" y="0" width="1000" height="1000"><path d="'+pth(A.a0-6,A.a1+6,30)+'" fill="none" stroke="#fff" stroke-width="96" stroke-linecap="round"/></mask></defs><image href="'+A.bg+'" x="0" y="0" width="1000" height="1000" preserveAspectRatio="none" mask="url(#wbArcM)"/>';
    svg.parentNode.insertBefore(bg,svg);
    var CVA=document.createElement('canvas').getContext('2d');
    function upd(){
      if(!svg.querySelector('#wbArcP')){var d=svg.querySelector('defs');if(!d){d=document.createElementNS(NS,'defs');svg.insertBefore(d,svg.firstChild);}var pe=document.createElementNS(NS,'path');pe.setAttribute('id','wbArcP');pe.setAttribute('d',pth(A.a0,A.a1,0));d.appendChild(pe);}
      var T=svg.querySelector('text.wb-arc-t');
      if(!T){T=document.createElementNS(NS,'text');T.setAttribute('class','wb-arc-t');var tp=document.createElementNS(NS,'textPath');tp.setAttribute('href','#wbArcP');tp.setAttribute('startOffset','50%');T.appendChild(tp);svg.appendChild(T);}
      var r=(GM.rows||[])[0],v=r?String(r.input.value||'').trim():'',s=v==='OHNE'?'':(v||A.ph);
      var ff="'"+A.ff+"'";CVA.font='100px '+ff;var xh=CVA.measureText('x').actualBoundingBoxAscent||47.5;
      var fs=A.xh/xh*100,w=CVA.measureText(s).width*fs/100,L=svg.querySelector('#wbArcP').getTotalLength();
      if(w>L*0.98)fs*=L*0.98/w;
      T.setAttribute('font-family',ff);T.setAttribute('font-size',fs.toFixed(2));T.setAttribute('text-anchor','middle');T.setAttribute('fill',A.fill);
      T.classList[v?'remove':'add']('is-ph');
      if(T.firstChild.textContent!==s)T.firstChild.textContent=s;
    }
    var run=safe(upd);
    document.addEventListener('input',function(e){if((GM.rows||[]).some(function(r){return r.input===e.target;}))run();});
    document.addEventListener('change',function(){setTimeout(run,0);});
    new MutationObserver(function(){if(!svg.querySelector('text.wb-arc-t')||!svg.querySelector('#wbArcP'))run();}).observe(svg,{childList:true});
    if(document.fonts&&document.fonts.load)document.fonts.load("100px '"+A.ff+"'").then(run,run);
    run();
  }

  /* ---------- 10. Leichte Kruemmung der Schrift auf runden Glaesern (wie im Produktfoto gemessen) ---------- */
  /* Wert = Durchhang der Grundlinie im Verhaeltnis zur Zeilenbreite (positiv: Enden hoeher, wie auf dem Foto von leicht oben) */
  var BEND={'gm-preview-sekt':{'sektglas-leonardo-daily-br-weil-du-die-liebe-meines-lebens-bist-2-glaser-mit-wunschname-datum-1':0.035}};
  function bendInit(){
    var l=lay();if(!l)return;
    var cfgB=BEND[window.GM_PREFIX||''],k=location.pathname.split('/').pop(),amt=cfgB&&cfgB[k];if(!amt)return;
    var svg=$('.gm-cfg--lay .gm-svg');if(!svg||svg.__wbBend)return;svg.__wbBend=1;
    var NS='http://www.w3.org/2000/svg',bbusy=false;
    var st=document.createElement('style');st.textContent='.gm-cfg--lay .gm-svg text[data-i].wb-bent{visibility:hidden!important}';document.head.appendChild(st);
    function upd(){
      if(bbusy)return;bbusy=true;
      try{
        var defs=svg.querySelector('defs');if(!defs){defs=document.createElementNS(NS,'defs');svg.insertBefore(defs,svg.firstChild);}
        $$('text[data-i]',svg).forEach(function(el){
          var i=el.getAttribute('data-i'),pid='wbBend'+i,s=el.textContent||'';
          if(!el.classList.contains('wb-bent'))el.classList.add('wb-bent');
          var x=+el.getAttribute('x'),y=+el.getAttribute('y'),fs=+el.getAttribute('font-size')||20,bb;
          try{bb=el.getBBox();}catch(e){bb=null;}
          var cx=bb&&bb.width?bb.x+bb.width/2:x,w=Math.max(bb&&bb.width?bb.width*1.4:0,fs*6),h=amt*w;
          var d='M'+(cx-w/2).toFixed(1)+' '+(y-h).toFixed(1)+' Q'+cx.toFixed(1)+' '+(y+h).toFixed(1)+' '+(cx+w/2).toFixed(1)+' '+(y-h).toFixed(1);
          var pe=svg.querySelector('#'+pid);if(!pe){pe=document.createElementNS(NS,'path');pe.setAttribute('id',pid);defs.appendChild(pe);}
          if(pe.getAttribute('d')!==d)pe.setAttribute('d',d);
          var T=svg.querySelector('text.wb-bend-t[data-for="'+i+'"]');
          if(!T){T=document.createElementNS(NS,'text');T.setAttribute('class','wb-bend-t');T.setAttribute('data-for',i);var tp=document.createElementNS(NS,'textPath');tp.setAttribute('href','#'+pid);tp.setAttribute('startOffset','50%');T.appendChild(tp);svg.appendChild(T);}
          ['font-family','font-size','fill','font-weight','font-style','letter-spacing'].forEach(function(a){var v=el.getAttribute(a);if(v==null)T.removeAttribute(a);else if(T.getAttribute(a)!==v)T.setAttribute(a,v);});
          T.setAttribute('text-anchor','middle');
          var ph=el.classList.contains('is-ph');if(T.classList.contains('is-ph')!==ph)T.classList[ph?'add':'remove']('is-ph');
          if(T.firstChild.textContent!==s)T.firstChild.textContent=s;
        });
      }finally{bbusy=false;}
    }
    var run=safe(upd);
    new MutationObserver(function(ms){if(bbusy)return;if(ms.some(function(m){var t=m.target;if(t.nodeType===3)t=t.parentNode;if(m.type==='childList'&&t===svg)return [].some.call(m.addedNodes,function(n){return !(n.classList&&n.classList.contains('wb-bend-t'));})||m.removedNodes.length>0;return !(t&&t.closest&&t.closest('defs,.wb-bend-t'));}))run();}).observe(svg,{attributes:true,subtree:true,childList:true,characterData:true});
    run();
  }

  /* ---------- 11. Wunschname-Umschalter: Beschriftung in normaler Schreibweise ---------- */
  function wnText(){
    $$('.custom-condition-btn .related-condition-btn').forEach(function(b){
      var t=b.textContent,n=t.replace(/\b(OHNE|MIT|WUNSCHNAMEN?)\b/g,function(w){return w.charAt(0)+w.slice(1).toLowerCase();});
      if(n!==t)b.textContent=n.trim();
    });
  }

  /* ---------- 12. Set-Auswahl: Ersparnis des 2er-Sets gegenueber 2 x 1 Glas anzeigen ---------- */
  function num(s){var m=String(s||'').match(/(\d{1,3}(?:\.\d{3})*),(\d{2})/);return m?parseFloat(m[1].replace(/\./g,'')+'.'+m[2]):NaN;}
  function eur(v){return v.toFixed(2).replace('.',',')+' €';}
  function setSave(){
    var cards=$$('label.cust-swatch').map(function(l){
      var h=$('.card__heading',l)&&txt($('.card__heading a',l)||$('.card__heading',l)),pe=$$('.product-price',l);
      return{l:l,t:h||'',pe:pe,p:pe.length?num(pe[0].textContent):NaN};
    }).filter(function(c){return c.pe.length&&c.p>0;});
    var one=cards.filter(function(c){return /^1\s*Glas$/i.test(c.t);})[0];if(!one)return;
    cards.forEach(function(c){
      var m=c.t.match(/^(\d)\s*Gl(a|ä)ser$/i);if(!m)return;
      var n=+m[1],full=Math.round(one.p*n*100)/100,save=Math.round((full-c.p)*100)/100;
      var pct=Math.round(save/full*100),key=full+'|'+c.p;
      c.pe.forEach(function(pe){
        var box=pe.nextElementSibling;if(box&&!box.classList.contains('wb-save'))box=null;
        if(!(save>=0.5)){if(box)box.remove();return;}
        if(box&&box.getAttribute('data-k')===key)return;
        if(!box){box=document.createElement('span');box.className='wb-save';pe.parentNode.insertBefore(box,pe.nextSibling);}
        box.setAttribute('data-k',key);
        box.innerHTML='<s><span class="visually-hidden">statt </span>'+eur(full)+'</s> <b><span aria-hidden="true">−'+pct+' %</span><span class="visually-hidden">Du sparst '+eur(save)+' ('+pct+' Prozent)</span></b>';
      });
    });
  }
  function setSaveInit(){
    var run=safe(function(){setSave();wnText();});run();
    var host=$('.product__info-container')||document.body;
    var t=null;new MutationObserver(function(ms){if(ms.every(function(m){return m.target.closest&&m.target.closest('.wb-save');}))return;clearTimeout(t);t=setTimeout(run,150);}).observe(host,{childList:true,subtree:true});
  }

  /* ---------- Start ---------- */
  function poll(fn,max,ms){var n=0;(function f(){var ok=false;try{ok=fn();}catch(e){ok=true;if(window.console)console.warn('wb-fix',e);}if(!ok&&++n<max)setTimeout(f,ms);})();}
  document.addEventListener('gm:cfg-ready',function(){
    setTimeout(function(){
      poll(function(){if(!$('.gm-cfg--lay .gm-svg'))return false;eqInit();zoomFix();guardInit();arcInit();noteFix();bendInit();return true;},30,200);
      poll(function(){var W=window.__WBP;if(!W||!W.ST||!W.ST.ready)return false;return order();},40,200);
    },200);
  });
  function onLoad(){poll(buyBox,25,300);setTimeout(buyBox,3500);safe(setSaveInit)();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',onLoad);else onLoad();
})();
